import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">
              Our Next-Gen <span>Technology Stack</span>
            </h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              As an innovative Android app development agency that strives for
              the enhancement of app solutions, we utilize the latest
              technologies to create your business applications. Here is the
              diverse tech stack that our Android app developers and designers
              leverage to build state-of-the-art applications:
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Languages">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/javascript.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>JavaScript</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/csharp.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Csharp</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/java.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Java</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/vector.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Kotlin</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Frameworks">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/android-new/frameworks/android.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Android SDK</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/android-new/frameworks/cordova.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Cordova</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/android-new/frameworks/jetpack_compose.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Jetpack</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/android-new/frameworks/xamarin.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Xamarin</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/android-new/frameworks/flutter.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Flutter</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/android-new/frameworks/native.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>React Native</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/android-new/frameworks/ionic.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Ionic</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Libraries">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/android-new/library/android_ndk.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Android Ndk</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/android-new/library/dagger2.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Dagger2</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/android-new/library/firebase_cloudmessaging.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Firebase</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/android-new/library/kotlin_flow.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>kotlin flow</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/android-new/library/rxjava.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Rxjava</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Database">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/android-new/database/cassandria.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Cassandra</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/database/mongodb.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MongoDB</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/database/mysql.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MySQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/database/postgre.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Postgre</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
